import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import Button from "../../coraWebComponents/buttons/Button";
import ziadostPropTypes from "../../propTypes/ziadostPropTypes";
import withRouter from "../../coraWebComponents/utils/withRouter";

class Uvod extends React.Component {
  render() {
    const { className, cancel, moveNext, ziadost } = this.props;
    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-8 offset-2 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              <div className="card-title">
                <div>{`Vyjadrenie k žiadosti ${ziadost.KOD_ZIADOSTI}`}</div>
              </div>

              {/* BUTTONS */}
              <div className="k-form-field flexGroup">
                <Button primary label="Zrusiť" onClick={cancel} />
                <Button label="Ďalej" onClick={moveNext} primary />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ziadost: state.ziadost.data,
  };
};

const mapDispatchToProps = (dispatch) => ({});

Uvod.propTypes = {
  moveNext: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  className: PropTypes.string,
  ziadost: ziadostPropTypes.ziadost,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Uvod));
